// @ts-check
import { createSimpleSlice } from '../createSimpleSlice';
import * as reducers from './actions';
import * as selectors from './selectors';
import { initialState } from './state';

const exportTemplateSlice = createSimpleSlice({
  name: 'exportTemplate',
  initialState,
  reducers,
});

export const exportTemplateActions = exportTemplateSlice.actions;
export const exportTemplateReducer = exportTemplateSlice.reducer;
export const exportTemplateSelectors = selectors;
